var map = {
	"./card-1.svg": "c65d",
	"./empty-cart.svg": "cb69",
	"./empty-state-no-data.svg": "3c14",
	"./en.svg": "bc04",
	"./fr.svg": "6ed2",
	"./megaphone.svg": "36b7",
	"./star-half.svg": "6ff5",
	"./star-muted.svg": "c145",
	"./star.svg": "42a8",
	"./top-vendor.svg": "41d5",
	"./wave-pattern-light.svg": "48ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";